import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { DemoData } from "./NetTypes";

export async function getDemoDataRequest(token: string, connectionToken: string) {
	return await apiClient
		.get(API.QUERY.DEMO.DATA(connectionToken), {
			headers: {
				Authorization: `Bearer ${token}`
			}
		})
		.then((res) => res.data);
}

export function useGetDemoDataRequest(token: string, connectionToken: string) {
	return useQuery<DemoData, AxiosError>({
		queryKey: ["demo", "data"],
		queryFn: () => getDemoDataRequest(token, connectionToken)
	});
}
